export default [
  /*
   -------------------------------------------------------------------------------------------------------
   ------------------------------------------AuthenticationUser-------------------------------------------------------
   -------------------------------------------------------------------------------------------------------
   */

  {
    path: '/RedefinirSenha/:user_email',
    name: 'RedefinirSenha',
    component: () => import('@/components/AuthenticationUser/RedefinirSenha.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/redefinirSenha',
    name: 'auth-reset-password-v1',
    component: () => import('@/components/AuthenticationUser/RedefinirSenhaLogin.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/VerificarEmail',
    name: 'verificarEmail',
    component: () => import('@/components/AuthenticationUser/VerificarEmail.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },

  {
    path: '/integrations/activecampaign',
    name: 'activecampaign',
    component: () => import('@/components/popUpActivecampaign/Activecampaign.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },

  /*
   -------------------------------------------------------------------------------------------------------
   ------------------------------------------PLANO-UPGRADE-------------------------------------------------------
   -------------------------------------------------------------------------------------------------------
   */

  {
    path: '/planoupgrade',
    name: 'planoupgrade',
    component: () => import('@/components/planos/PlanoUpgrade.vue'),
    meta: {
      resource: 'Auth',
    },
  },
]
